<template>
    <div class="footer">
        <div class="w">
            <div class="flex space-around text-center">
                <div class="flex-item">
                    <div style="margin: auto; width: 100px;height: 100px;">
                        <img style="vertical-align: middle;display: inline-block;" class="center-img" src="./../../../image/img/truck-moving.png" alt="">
                    </div>
                    <p v-if="agentLevel === 1 || agentLevel === 4" class="intr">免运费</p>
                    <p v-else-if="agentLevel === 2 || agentLevel === 5" class="intr">支付金额>=1000元包邮</p>
                    <p v-else-if="agentLevel === 3" class="intr">支付金额>=20000元包邮</p>
                </div>
                <div class="flex-item">
                    <div style="margin: auto; width: 100px;height: 100px;">
                        <img style="vertical-align: middle;display: inline-block;" class="center-img" src="./../../../image/img/comment-alt-smile.png" alt="">
                    </div>
                    <p class="intr">联系方式 400-189-8906</p>
                    <!-- <p class="intr"></p> -->
                </div>
                <div class="flex-item">
                    <img style="margin: auto; width: 100px;height: 100px;" class="center-img" src="./../../../image/img/weixin_officialaccount.png" alt="">
                    <p class="intr">UIOT公众号</p>
                </div>
                <div class="flex-item">
                    <img style="margin: auto; width: 100px;height: 100px;" class="center-img" src="./../../../image/img/weixin_service.png" alt="">
                    <p class="intr">客服微信</p>
                </div>
            </div>
            <div class="flex just-between border-top p-50-0 m-t-30">
            </div>
            <div class="text-center">
                <img style="margin: auto; width: 300px;" src="./../../../image/img/logo.png" alt="">
                <p class="font-26 font-more-thin m-t-20">许科技以匠心！许伙伴以厚利！许大众以惊喜！</p>
            </div>
            <p class="copyright border-top m-t-20 text-center">
                © 2012-{{nowYear}} 版权所有：超级智慧家（上海）物联网科技有限公司  沪ICP备16004537号-1
            </p>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                nowYear: '',
                footList: [
                    // [
                    //     {
                    //         name: '支付方式',
                    //         url: ''
                    //     },
                    //     {
                    //         name: '发货和物流',
                    //         url: ''
                    //     },
                    //     {
                    //         name: '退换货条款',
                    //         url: ''
                    //     }
                    // ],
                    // [
                    //     {
                    //         name: '技术支持',
                    //         url: ''
                    //     },
                    //     {
                    //         name: '售后服务政策',
                    //         url: ''
                    //     }
                    // ]
                ]
            }
        },
        mounted() {
            // 获取当前时间
            const nowTime = new Date()
            this.nowYear = nowTime.getFullYear()
        },
        computed: {
            agentLevel() {
                return this.$store.getters.getUserInfo.agentInfo.agentLevel2
            },
        },
        methods: {
        }
    }
</script>
<style>
    .footer{
        padding-bottom: 10px;
        background: #ffffff;
    }
    .footer .links{
        text-align: center;
        color: #666;
        line-height: 30px;
    }
    .footer .links .link{
        padding: 0 10px;
    }
    .footer .copyright{
        color: #6C7073;
        line-height: 40px;
    }
    .footer .fa{
        font-size: 50px;
        line-height: 50px;
        padding: 40px 0 24px;
    }
    .footer .intr{
        font-size: 14px;
        font-weight: 400;
        color: #6C7073;
        line-height: 22px;
    }
    .footer .weixin-qrcode{
        width: 95px;
    }
    .footer ul>li{
        color: #6C7073;
    }
    /* .footer ul>li:first-child{
        font-size: 12px;
        font-weight: 500;
        color: #3B3E40;
        line-height: 17px;
        font-weight: 600;
    } */
    .center-img{
        margin: 40px auto 27px;
        height: 40px;
    }

    .footer .p-50-0{
        padding: 30px 0 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/footer/index.vue